import { render } from "./FeedPage.vue?vue&type=template&id=f0fbc6e6&scoped=true"
import script from "./FeedPage.vue?vue&type=script&lang=js"
export * from "./FeedPage.vue?vue&type=script&lang=js"

import "./FeedPage.vue?vue&type=style&index=0&id=f0fbc6e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fbc6e6"]])

export default __exports__